import { render, staticRenderFns } from "./OrderTypesFormInput.vue?vue&type=template&id=2950d534&scoped=true&"
import script from "./OrderTypesFormInput.vue?vue&type=script&lang=js&"
export * from "./OrderTypesFormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2950d534",
  null
  
)

/* custom blocks */
import block0 from "./OrderTypesFormInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports